import styled from 'styled-components';
import { mixins } from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: ${tokens.primitive.space[9]} ${tokens.primitive.space[18]};
  background-color: ${tokens.semantic.color.background.roomInfo};
  border-radius: ${tokens.primitive.radius[10]};
  min-width: 200px;
  min-height: 49px;
`;

export const RoomNumber = styled.div`
  ${mixins.textRoomNumber}
`;

export const RoomDetails = styled.div`
  ${mixins.textRoomDetails}
  margin-inline-start: ${tokens.primitive.space[16]};
`;

export const RoomTitleContainer = styled.div`
  display: flex;
  align-items: center;
  > * + * {
    margin-inline-start: ${tokens.primitive.space[9]};
  }
`;

export const RoomInfoContainer = styled.div`
  ${mixins.flexColumn}
  > * + * {
    margin-top: ${tokens.primitive.space[3]};
  }
`;

export const AccentColorText = styled.span`
  ${mixins.accentColor}
`;

export const LocationMarker = styled.i`
  ${mixins.accentColor}
  font-family: ${tokens.primitive.typography.fontFamily.base};
  font-size: ${tokens.primitive.typography.fontSize[11]};
  border-bottom: ${tokens.primitive.space[1]} solid;
  border-radius: ${tokens.primitive.radius[3]};
`;
